<div class="d-flex flex-column w-100 upload-container">
  <div [ngClass]="{ 'flex-column h-100 overflow-y-auto': baseService.isMobile }" class="d-flex h-100 w-100">
    <div [ngClass]="isFileView && !baseService.isMobile ? 'w-50' : 'w-100'" class="d-flex flex-column p-3 gap-2">
      <label appDnd class="drag-n-drop-wrapper cursor-pointer" (fileDropped)="onDroppedFiles($event)">
        <div class="drag-n-drop-container crm-scroll">
          @if (!uploadingFiles.length) {
            <div>
              <input
                [accept]="$safeNavigationMigration(allowedMediaTypes?.join(', '))"
                [disabled]="maxUploadFiles && uploadedFiles.length >= maxUploadFiles - outsideFilesLength"
                (change)="onChooseFiles($event)"
                type="file"
                id="actual-btn"
                hidden
                multiple
                (click)="resetInput($event)"
              />
              <span class="button">
                <span class="click-span">{{ 'click_here' | translate }}</span> {{ 'or_transfer_files' | translate }}
              </span>
              <br />
              <span class="text-black fw-bold"
                >{{ 'you_have_uploaded' | translate }} {{ 'files' | translate }}: {{ uploadedFiles.length }}
                @if (maxUploadFiles) {
                  {{ 'from' | translate }} {{ maxUploadFiles - outsideFilesLength }}
                }
              </span>
            </div>
          }

          @for (file of uploadingFiles; let i = $index; track i) {
            <div class="file-upload cursor-pointer">
              <div class="d-flex flex-column w-100 gap-1 text-center overflow-hidden">
                <app-icon>image</app-icon>
                <span class="text-truncate">{{ file.data.name }}</span>
              </div>

              @if (uploadingFiles[i] && uploadingFiles[i].response && !uploadingFiles[i].response.state) {
                <mat-progress-bar mode="determinate" value="{{ uploadingFiles[i].response.progress }}" />
              }

              <app-button class="delete-file-button" btnType="icon" (onChangeClick)="deleteUploadingFile(i)">
                <app-icon>delete</app-icon>
              </app-button>
            </div>
          }
        </div>
      </label>
      <!--      <div class="d-flex flex-wrap align-items-center gap-2 w-100">-->
      <!--        <span class="text-truncate">{{ 'or_paste_a_link' | translate }}:</span>-->
      <!--        <div class="d-flex align-items-center gap-2 w-100">-->
      <!--          <app-text-field placeholder="URL" class="w-100"></app-text-field>-->
      <!--          <app-button>{{ 'upload' | translate }}</app-button>-->
      <!--        </div>-->
      <!--      </div>-->
      @if (uploadedFiles.length) {
        <div class="d-flex files flex-column gap-2 w-100">
          <mat-divider></mat-divider>
          <span class="fw-bold">{{ 'uploaded_files' | translate }}:</span>
          <div class="d-flex files-list flex-column w-100 gap-2 crm-scroll">
            @for (file of uploadedFiles; let i = $index; track i) {
              <div
                (click)="onViewFile(file, i)"
                class="file cursor-pointer"
                [ngClass]="{ active: selectedFileIndex === i }"
              >
                <div class="d-flex align-items-center w-100 gap-1 overflow-hidden">
                  @if (file.type === ATTACHMENTS_TYPES.IMAGE) {
                    <img class="uploaded_img" draggable="false" [src]="file.link" alt="uploaded file img" />
                  } @else {
                    <img
                      draggable="false"
                      [src]="
                        UPLOAD_FILE_ICONS[file.formattedType] || UPLOAD_FILE_ICONS[file.type?.toLowerCase() || 'file']
                      "
                      alt="uploaded file icon"
                    />
                  }
                  <span class="text-truncate">{{ file.name }}</span>
                </div>
                <app-button
                  (onChangeClick)="$event.stopPropagation(); deleteUploadedFile(i)"
                  class="d-flex z-5"
                  btnType="icon"
                >
                  <app-icon>delete</app-icon>
                </app-button>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (isFileView) {
      <div
        [ngClass]="isFileView ? 'w-100' : 'w-50'"
        class="d-flex align-items-center justify-content-center p-3 viewer"
      >
        @if (isLoader && file?.type !== ATTACHMENTS_TYPES.IMAGE) {
          <div class="d-flex justify-content-center">
            <app-loader size="small"></app-loader>
          </div>
        }

        @if (file?.type === ATTACHMENTS_TYPES.IMAGE) {
          <img [src]="file.link" alt="fileview img" />
        } @else {
          <ngx-doc-viewer
            [ngClass]="{ 'd-none': isLoader }"
            url="{{ file.link }}"
            viewer="google"
            style="height: 100%; width: 100%"
            (loaded)="fileLoaded()"
          />
        }
      </div>
    }
  </div>

  @if (uploadedFiles.length) {
    <mat-divider />
    <div class="d-flex align-items-center gap-2 p-3 flex-wrap justify-content-end">
      @if (isFileChoice) {
        <app-checkbox [(ngModel)]="sendAsFile" [disabled]="forceFile">
          {{ 'send_as_file' | translate }}
        </app-checkbox>
      }
      <div class="flex-fill"></div>
      <div class="d-flex gap-2 justify-content-end align-items-center">
        <app-button (onChangeClick)="onCancelModal()" [customClass]="'bg-danger'">{{
          'cancel' | translate
        }}</app-button>
        <app-button [disabled]="!!uploadingFiles.length" (onChangeClick)="onCloseModal()">{{
          'save' | translate
        }}</app-button>
      </div>
    </div>
  }
</div>
